import { ACCOUNT_POINTS, ACCOUNT_REDEMPTIONS, AUTH_EMAIL, AUTH_LOGIN, UPDATE_PROFILE } from '../state/constants/apiConstants';
import { axiosInstance } from './axiosInstance';
import SessionService from './session';

const ProfileService = {

  updateProfile: async (data, success, error) => {
    try {
      success(await axiosInstance.put(UPDATE_PROFILE, data, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': SessionService.getIdTokenData()
        }
      }));
    } catch (_error) {
      error(_error);
    }
  },

  deleteUser: async (email, success, error) => {
    try {
      success(await axiosInstance.delete(`${UPDATE_PROFILE}/${email}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': SessionService.getIdTokenData()
        }
      }));
    } catch (_error) {
      error(_error);
    }
  },

  updateDirection: async (data, success, error) => {
    try {
      success(await axiosInstance.post(UPDATE_PROFILE, data));
    } catch (_error) {
      error(_error);
    }
  },

  validateEmail: async (data, success, error) => {
    try {
      success(await axiosInstance.post(AUTH_EMAIL, data));
    } catch (_error) {
      error(_error);
    }
  },

  authLogin: async (data, success, error) => {
    try {
      success(await axiosInstance.post(AUTH_LOGIN, data));
    } catch (_error) {
      error(_error);
    }
  },

  myPoints: async (success, error) => {
    const data = SessionService.getUserData();
    try {
      success(await axiosInstance.get(ACCOUNT_POINTS + `?email=${data.email}`));
    } catch (_error) {
      error(_error);
    }
  },

  myPointsTest: async (email) => {
    return await axiosInstance.get(ACCOUNT_POINTS + `?email=${email}`).then(resp => resp.data);
  },

  myRedemptions: async (success, error) => {
    try {
      // is valid token
      success(await axiosInstance.get(ACCOUNT_REDEMPTIONS, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': SessionService.getIdTokenData()
        }
      }));
    } catch (_error) {
      error(_error);
    }
  }
};

export default ProfileService;